export default 'redux-responsive/CALCULATE_RESPONSIVE_STATE';


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-responsive/lib/actions/types/CALCULATE_RESPONSIVE_STATE.js
// module id = 169
// module chunks = 3